import type { ILeadCompanyRequiredFieldsInput } from '@user/store/lead/typings'
import type { IAutoReviewMissingField } from '@user/store/draftLeads/typings'
import type { AutoReviewLookups } from '@user/features/PendingLeadAutoReview/typings'
import { buildAutoReviewInput } from '@user/features/PendingLeadAutoReview/utils/buildAutoReviewInput'

import type { LeadCompanyRequiredFieldsFormValues } from '../hooks/useInitialValues'
import type { LeadExtraFieldKey } from './mapMissingFieldsToForm'

/**
 * Builds the request body from the rendered fields only. The shared Pending Lead builder resolves
 * the id and name pairs; its source keys are renamed to the lead's leadSource keys.
 */
export function buildCompanyRequiredFieldsInput(
  values: LeadCompanyRequiredFieldsFormValues,
  fields: IAutoReviewMissingField[],
  extraKeys: LeadExtraFieldKey[],
  lookups: AutoReviewLookups,
): ILeadCompanyRequiredFieldsInput {
  const { sourceId, source, ...shared } = buildAutoReviewInput(
    values,
    fields,
    lookups,
  )
  const input: ILeadCompanyRequiredFieldsInput = { ...shared }

  if (sourceId && source) {
    input.leadSourceId = sourceId
    input.leadSource = source
  }
  if (
    extraKeys.includes('preferredMethodOfContact') &&
    values.preferredMethodOfContact
  )
    input.preferredMethodOfContact = values.preferredMethodOfContact
  if (
    extraKeys.includes('preferredTimeOfContact') &&
    values.preferredTimeOfContact.length > 0
  )
    input.preferredTimeOfContact = values.preferredTimeOfContact.join(',')
  if (extraKeys.includes('nextActionDate') && values.nextActionDate)
    input.nextActionDate = values.nextActionDate

  return input
}
